"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var messages = {
  de: {
    orders: {
      actions: {
        addNewOrder: 'Neue Bestellung erstellen',
        all: 'Alle Bestellungen'
      },
      listPage: {
        title: 'Bestellungen',
        table: {
          filter: {
            number: 'Nummer'
          },
          columns: {
            contact: 'Kontakt',
            dateOfOrder: 'Bestelldatum',
            number: 'Nummer',
            offer: 'Angebot',
            opportunity: 'Gelegenheit',
            owner: 'bestellt von',
            state: 'Zustand',
            total: 'Zusammen',
            totalUserCurrency: 'Zusammen {currency}'
          }
        }
      },
      order: {
        newEntity: 'neue Bestellung',
        contact: {
          label: 'Kontakt',
          helperText: '',
          helperTextPreview: ''
        },
        commissionTotal: {
          label: 'Gesamtprovision',
          helperText: '',
          helperTextPreview: ''
        },
        currency: {
          label: 'Währung',
          helperText: '',
          helperTextPreview: ''
        },
        dateOfOrder: {
          label: 'Bestelldatum',
          helperText: '',
          helperTextPreview: ''
        },
        number: {
          label: 'Nummer',
          helperText: 'Für die automatische Nummerngenerierung lassen Sie das Feld leer.',
          helperTextPreview: ''
        },
        offer: {
          label: 'Angebot',
          helperText: '',
          helperTextPreview: ''
        },
        opportunity: {
          label: 'Gelegenheit',
          helperText: '',
          helperTextPreview: ''
        },
        owner: {
          label: 'bestellt von',
          helperText: '',
          helperTextPreview: ''
        },
        salesMargin: {
          label: 'Marge',
          helperText: '',
          helperTextPreview: ''
        },
        subjects: {
          title: 'Předmět',
          discount: {
            label: 'Rabatt',
            helperText: '',
            helperTextPreview: ''
          },
          commission: {
            label: 'Provision',
            helperText: '',
            helperTextPreview: ''
          },
          list: {
            package: 'Verpackungseinheit'
          },
          listPrice: {
            label: 'Listenpreis',
            helperText: '',
            helperTextPreview: ''
          },
          price: {
            label: 'Verkaufspreis',
            helperText: '',
            helperTextPreview: ''
          },
          product: {
            label: 'Artikel',
            helperText: '',
            helperTextPreview: ''
          },
          quantity: {
            label: 'Menge',
            helperText: '',
            helperTextPreview: ''
          },
          salesMargin: {
            label: 'Marge',
            helperText: '',
            helperTextPreview: ''
          },
          subjectTotal: {
            label: 'Zusammen je position',
            helperText: '',
            helperTextPreview: ''
          },
          unit: {
            label: 'Einheit',
            helperText: '',
            helperTextPreview: ''
          }
        },
        total: {
          label: 'Zusammen',
          helperText: '',
          helperTextPreview: ''
        },
        numberOfSubjects: '{number, plural, =0 {žádné položky} eine {1 položka} mehrere {{number} položky} andere {{number} položek}}'
      },
      myOrdersScoringBlog: {
        title: 'Meine Bestellungen'
      },
      ordersList: 'Bestellungen'
    }
  }
};
var _default = messages;
exports.default = _default;